import { ActionsObservable } from 'redux-observable';
import { Store } from 'redux';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import { AjaxCreationMethod } from 'rxjs/observable/dom/AjaxObservable';
import {
  ViewMessagesRequest,
  viewMessagesFailure,
  viewMessagesSuccess,
  AppAction,
  messageCategoryData,
} from '../actions';
import { VIEW_MESSAGES_REQUEST } from '../constants';
import { AppState, AuthState, MessageCategory, Messages } from '../models';
import { getCannedMessageEndpoint } from '../configs';
import * as epicCommon from './epicCommon';
import * as errorUtil from '../utils/errorUtil';
import * as Mustache from 'mustache';

const renderMessagesWithDisplayName = (messages: Messages, displayName?: string): Messages => {
  displayName && messages.map((m) => {
    m.text = Mustache.render(m.text, { userProfile: { displayName } });
  });

  return messages;
};

export const getMessages =
  (action$: ActionsObservable<AppAction>,
   store: Store<AppState>,
   ajax: AjaxCreationMethod): Observable<AppAction> => {

    return action$.ofType(VIEW_MESSAGES_REQUEST)
      .mergeMap((viewActionRequest: ViewMessagesRequest) => {
        const state: AuthState = store.getState().authState;
        const endpoint = getCannedMessageEndpoint();
        const urlCategories = `${endpoint}canned-message-category`;
        const categoryObservable = 
        ajax.getJSON(urlCategories, epicCommon.getHttpHeaders(state.authToken));
        const url = `${endpoint}canned-messages?expertId=${state.expertId}`;
        const messagesObservable = ajax.getJSON(url, epicCommon.getHttpHeaders(state.authToken));
        return categoryObservable.flatMap((categories: any[]) => {
          const messageCategories: MessageCategory[] = categories.map(c => ({
            categoryName: c.name,
            id: c.id,
            messages: [],
            displayOrder: (c.displayOrder || 0),
          }));
          store.dispatch(messageCategoryData(messageCategories));
          return messagesObservable
            .mergeMap((res: Messages) => {
              const renderedMessages = renderMessagesWithDisplayName(res, state.technicianName);
              
              return Observable.of(viewMessagesSuccess(renderedMessages));
              
            })
            .catch((err) => {
              errorUtil.throwErrorAsync(err);
              return Observable.of(viewMessagesFailure(epicCommon.extractMessage(err)));
            },
          );
        }).catch((err) => {
          errorUtil.throwErrorAsync(err);
          return Observable.of(viewMessagesFailure(epicCommon.extractMessage(err)));
        },
        );
      });
  };





// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/getMessages.ts